export enum BRAND_TYPE {
  STANDARD = 'standard',
  STARTER = 'starter',
}

export enum PAY_BY {
  CREDIT_CARD = 'credit_card',
  INVOICE = 'invoice',
  FREE = 'free',
}

export enum STATUS {
  APPROVED = 'approved',
  FAILED = 'failed',
  SUBMITTED = 'submitted',
  NOT_SUBMITTED = 'not_submitted',
  ADDITIONAL_DATA_COLLECTION_REQUIRED = 'additional_data_collection_required',
  UNREGISTERED = 'unregistered',
}

export enum BusinessRegistrationIdentifier {
  EIN = 'EIN',
  CBN = 'CBN',
}

export const COMMUNITY_REGISTRATION_STATUS = {
  NOT_SET: 'NOT_SET',
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  REVOKED: 'REVOKED',
  EXEMPT: 'EXEMPT',
} as const

export type CommunityRegistrationStatus =
  typeof COMMUNITY_REGISTRATION_STATUS[keyof typeof COMMUNITY_REGISTRATION_STATUS]
